import { CSSProperties, FC, ReactNode } from 'react'
import styled from 'styled-components'

import { mediaMax } from 'styles/media'

import LazyImage from '../display/LazyImage'

const Outer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  & > img:first-child {
    ${mediaMax.md`
      min-height: unset;
      height: 50vh;
    `}
  }
`

type SinglePromoImageProps = {
  src: string
  annotationComp: ReactNode
  style?: CSSProperties
}

const SinglePromoImage: FC<SinglePromoImageProps> = ({
  src,
  annotationComp,
  style,
}) => {
  return (
    <Outer style={style}>
      <LazyImage data-src={src} rounded />
      <div style={{ marginTop: 20 }}>{annotationComp}</div>
    </Outer>
  )
}

export default SinglePromoImage
